export enum Step {
  Init = 0,
  CheckEmail = 2,
}
